<template>
  <div class="help landing-wrapper">
    <div class="help-block">
      <img class="help-block__img" src="@/assets/images/Home/anchor.svg" alt="logo" />

      <div class="help-block__content">
        <h2 class="help-block__title landing-title">{{ $t('help.title') }}</h2>
        <p class="text">{{ $t('help.text1') }}</p>
      </div>

      <p class="text mobile">{{ $t('help.text1') }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Help',
  computed: {
    ...mapGetters(['language']),
    isRussian() {
      return this.language === 'ru'
    },
    linkUrl() {
      return this.isRussian
        ? 'https://vk.com/@robuxpier-kak-kupit-robuksy'
        : 'https://instagram.com/ads.robuxpier?igshid=MzRlODBiNWFlZA=='
    }
  }
}
</script>

<style lang="scss" scoped>
@import './help';
</style>
